import React from "react";
import * as T from "@lib/types";
import { useApp } from "@lib/providers";
import { createRGBA } from "@lib/utils";

type TranscriptLineProps = {
  segments: T.TranscriptionWSResponse["message"]["data"]["transcriptionSegments"];
};

export default function TranscriptLine({ segments }: TranscriptLineProps) {
  const { config } = useApp();
  return (
    <>
      {segments.map((segment) => {
        const category = config.categories[segment.categoryId];
        const rgba = category ? createRGBA(category.highlight.backgroundColor) : "";
        const textRgba = category ? createRGBA(category.highlight.fontColor) : "";
        const marginLeft = segment.listRank === 0 ? 0 : 4;
        return segment.useCategory && category ? (
          <span key={segment.listRank} style={{ padding: 2, color: textRgba, backgroundColor: rgba, marginLeft }}>
            {segment.text}
          </span>
        ) : (
          <span key={segment.listRank} style={{ marginLeft }}>
            {segment.text}
          </span>
        );
      })}
    </>
  );
}
